import { Camera, ShoppingBag, Search, BarChart3 } from "lucide-react";

const ITEMS = [
  ["scan", "Scan", Camera],
  ["sell", "Sell", ShoppingBag],
  ["lookup", "Look up", Search],
  ["summary", "Summary", BarChart3],
];

export default function DeskBottomBar({ active, onSelect, canSell = true }) {
  const items = ITEMS.filter(([id]) => canSell || id !== "sell");
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t shadow-[0_-4px_16px_rgba(0,0,0,0.06)] pb-[env(safe-area-inset-bottom)]" data-testid="desk-bottom-bar">
      <div className={`grid ${items.length === 4 ? "grid-cols-4" : "grid-cols-3"}`}>
        {items.map(([id, label, Icon]) => (
          <button key={id} onClick={() => onSelect(id)} data-testid={`desk-nav-${id}`}
            className={`py-2.5 flex flex-col items-center gap-0.5 text-[11px] font-semibold transition-colors ${active === id ? "text-[#1e3a5f]" : "text-slate-400"}`}>
            <Icon className="w-5 h-5" />{label}
          </button>
        ))}
      </div>
    </nav>
  );
}
